<template>
  <div class="empty-container">
    <img
      :src="require('../../../assets/images/argicSubjectInfo/' + emptyImg)"
      alt=""
    />
    <p>{{ emptyTxt }}</p>
  </div>
</template>

<script>
export default {
  name: "Empty",
  props: {
    emptyTxt: {
      type: String,
      default: "暂无信息",
    },
    emptyImg: {
      type: String,
      default: "empty1.png",
    },
  },
};
</script>

<style scoped lang="scss">
.empty-container {
  text-align: center;
  padding: 100px 0px;
  img {
    width: 241px;
    height: 241px;
    margin-bottom: 16px;
  }
  p {
    color: #c4c4c4;
    font-size: 20px;
  }
}
</style>
